import { Controller } from '@hotwired/stimulus';

// LRPO-5669 — the territory builder's 30-second idle autosave can fail on every
// tick and save nothing, with the user never told.  The server returns the reason
// ({ status: "error", message: "...", errors: [...] }) with 422, but edit.html.erb
// only console.error'd it.  This controller listens for the failure event the
// autosave dispatches and puts the server's messages on screen so a failed
// autosave can never look like a successful one.

export default class extends Controller {
  connect() {
    this._failedHandler = (event) => this._onFailed(event)
    this._savedHandler = () => this._onSaved()
    document.addEventListener('territory:autosave-failed', this._failedHandler)
    document.addEventListener('territory:autosaved', this._savedHandler)
  }

  disconnect() {
    document.removeEventListener('territory:autosave-failed', this._failedHandler)
    document.removeEventListener('territory:autosaved', this._savedHandler)
  }

  _onFailed(event) {
    const detail = event.detail || {};
    const errors = Array.isArray(detail.errors) ? detail.errors : [];

    const alert = document.createElement('div');
    alert.className = 'alert alert-danger alert-dismissible fade show';
    alert.setAttribute('role', 'alert');
    alert.setAttribute('aria-live', 'assertive');

    // Heading — make clear that EVERYTHING failed, not just one row.
    const heading = document.createElement('p');
    heading.style.margin = '0 0 8px 0';
    heading.style.fontWeight = 'bold';
    heading.textContent = detail.message
      ? 'Your changes were not saved: ' + detail.message
      : 'Your changes were not saved.';
    alert.appendChild(heading);

    // List each server-supplied error as its own item (textContent only).
    if (errors.length > 0) {
      const list = document.createElement('ul');
      list.style.marginBottom = 0;
      errors.forEach(function (err) {
        const li = document.createElement('li');
        li.textContent = String(err);
        list.appendChild(li);
      });
      alert.appendChild(list);
    }

    // Dismiss button.
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'btn-close';
    close.setAttribute('data-bs-dismiss', 'alert');
    close.setAttribute('aria-label', 'Close');
    alert.appendChild(close);

    // Replace rather than append so repeated failures do not stack.
    this.element.replaceChildren(alert);
  }

  _onSaved() {
    // A later successful tick means the problem is resolved; clear stale banner.
    this.element.replaceChildren();
  }
}
